const onFailure = (error) => ({
  message: 'Conra já cadastrada!',
  type: 'warning',
});

export default onFailure;
